import React from 'react';
import './footer.css';

function Footer() {
  return (
    <footer className='bg-primary py-6'>
      <p className='size-1 txt-white fw-bold txt-center'>DECORA</p>
    </footer>
  );
}

export default Footer;
